import BaseUrl from "../component/BaseUrl";

export const getAllManager = async (search) => {
    try {
        const config = {
            headers: { Authorization: `Bearer ${JSON.parse(localStorage.getItem('pacificadmin'))?.token?.token}` }
        };
        const response = await BaseUrl.get(`/api/Users/GetCaseManagers?name=${search}`, config);
        return response;
    } catch (err) {
        return err.response
    }
}

export const saveManager = async (body) => {
    try {
        const config = {
            headers: { Authorization: `Bearer ${JSON.parse(localStorage.getItem('pacificadmin'))?.token?.token}` }
        };
        const response = await BaseUrl.post("/api/Users/SaveCaseManager", body, config);
        return response;
    } catch (err) {
        return err.response
    }
}

export const getManagerById = async (id) => {
    try {
        const config = {
            headers: { Authorization: `Bearer ${JSON.parse(localStorage.getItem('pacificadmin'))?.token?.token}` }
        };
        const response = await BaseUrl.get(`/api/Users/GetCaseManagerById/${id}`, config);
        return response;
    } catch (err) {
        return err.response
    }
}

export const updateManager = async (body) => {
    try {
        const config = {
            headers: { Authorization: `Bearer ${JSON.parse(localStorage.getItem('pacificadmin'))?.token?.token}` }
        };
        const response = await BaseUrl.put("/api/Users/UpdateCaseManager", body, config);
        return response;
    } catch (err) {
        return err.response
    }
}

export const deleteManager = async (id) => {
    try {
        const config = {
            headers: { Authorization: `Bearer ${JSON.parse(localStorage.getItem('pacificadmin'))?.token?.token}` }
        };
        const response = await BaseUrl.delete(`/api/Users/DeleteCaseManager/${id}`, config);
        return response;
    } catch (err) {
        return err.response
    }
}

